import { Pipe, PipeTransform } from "@angular/core";
import { lastField } from "../last-field";

@Pipe({ name: "attrKeyLastField" })
export class AttrKeyLastFieldPipe implements PipeTransform {
  public transform(key: string) {
    return lastField(key);
  }
}
